// pages/NewModulePage.tsx
import { useNavigate } from "react-router-dom";
import PageListLayout from "../../../layouts/PageListLayout";
import ModuleForm from "../../../components/features/modules/ModuleForm";
import { alertSuccess, alertError } from "../../../helpers/alertError";
import { BaseModule } from "../../../types/features/Module";
import { useState } from "react";
import { moduleService } from "../../../services/moduleService";

export default function NewModulePage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (data: BaseModule) => {
    setIsLoading(true);
    try {
      // Appel API pour créer le module
      console.log("Création du module:", data);
      await moduleService.createModule(data) // Simulation
      
      alertSuccess("Module créé avec succès !");
      navigate(-1);
    } catch (error) {
      alertError("Erreur lors de la création du module");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PageListLayout title="">
      <div className="px-6 py-5 bg-white border-b border-slate-100">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-2xl font-bold text-[#031B4E] tracking-tight">
            Nouveau module
          </h1>
          <p className="text-sm text-slate-400 font-light mt-0.5">
            Créez un nouveau module pour la plateforme
          </p>
        </div>
      </div>

      <div className="px-6 py-8 max-w-2xl mx-auto">
        <div className="bg-white rounded-xl border border-gray-200 p-6">
          <ModuleForm
            onSubmit={handleSubmit}
            onCancel={() => navigate("/admin/modules")}
            isLoading={isLoading}
          />
        </div>
      </div>
    </PageListLayout>
  );
}